<template>
  <div class="h-full" v-if="route.name">
    <metainfo>
      <template v-slot:title="{ content }">Refrag | {{ content }}</template>
    </metainfo>
    <router-view />
  </div>
  <div v-else class="h-full flex relative">
    <!-- Skeleton sidebar for desktop when loading -->
    <div class="hidden md:flex md:w-[210px] md:flex-col md:fixed md:inset-y-0 z-20">
      <SidebarSkeleton />
    </div>

    <!-- Skeleton main content area -->
    <div class="md:pl-52 flex flex-col min-w-full flex-1 min-h-full">
      <main class="h-full flex flex-col bg-gray-950">
        <!-- Skeleton navbar -->
        <div class="bg-gray-950 border-b border-gray-700 px-4 py-3 min-h-[65px] flex items-center justify-end">
          <div class="flex items-center justify-between">
            <div class="h-8 w-32 rounded animate-pulse" />
            <div class="flex items-center gap-4">
              <div class="h-8 w-24 bg-gray-800 rounded animate-pulse" />
              <div class="h-8 w-8 bg-gray-800 rounded-full animate-pulse" />
            </div>
          </div>
        </div>

        <div class="flex justify-center h-full items-center w-full">
          <Loader />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import SidebarSkeleton from './components/layouts/SidebarSkeleton.vue';
import Loader from './components/General/Loader.vue';

export default {
  components: {
    SidebarSkeleton,
    Loader,
  },
  setup() {
    const route = useRoute();
    return { route };
  },
};
</script>
